/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './live-channel.stache';
import can from 'can';
import domUtil from 'scripts/utils/dom';
import RouteCreator from 'scripts/services/route-creator';
import liveVideoService from 'scripts/services/live-video-service';
import appContext from 'scripts/app-context';

import { showLiveVideoModal } from 'components/live-video-modal/live-video-modal';

const inWebView = window.globalSettings.inWebView;

Component.extend({
    tag: 'live-channel',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            liveVideoCard: {
                Type: can.Map,
                Value: null,
            },
            isActive: {
                type: 'boolean',
                value: false,
            },
            isMobileWeb: {
                type: 'boolean',
                get() {
                    return (
                        ['small', 'extra-small'].indexOf(
                            appContext.model.screen.attr('screenSize'),
                        ) > -1 && !inWebView
                    );
                },
            },
            playerTags: {
                type: 'string',
                get() {
                    const playerTags =
                        this.attr('liveVideoCard.playerTagGroups') || [];

                    return playerTags.map((groupTag) =>
                        groupTag.map((playerTag) => playerTag.title).join(', '),
                    );
                },
            },
        },
        closeLiveVideoPlayer() {
            this.attr('isActive', false);
        },
        onVideoClick(event, liveVideoCard) {
            if (this.attr('isMobileWeb')) {
                showLiveVideoModal();
                return;
            }

            let liveMultiviewPlayerElement = can.$('live-multiline-player');
            if (
                liveMultiviewPlayerElement.length &&
                liveMultiviewPlayerElement.viewModel()
            ) {
                let players = (liveVideoCard.playerTagGroups || [])
                    .map((g) => g.map((p) => p.title).join(', '))
                    .join(', ');
                let holes = (liveVideoCard.holeTags || [])
                    .map((h) => h.title)
                    .join(', ');
                let title = `${players}${players && holes ? '. ' : ''}${
                    holes ? 'Holes: ' + holes : ''
                }`;
                let video = {
                    id: liveVideoCard.video.identifier,
                    header: liveVideoCard.title,
                    title,
                    autoplay: true,
                };
                liveMultiviewPlayerElement
                    .viewModel()
                    .setVideoInSelected(video);
                domUtil.scrollTop(0);

                liveMultiviewPlayerElement
                    .viewModel()
                    .attr('updateChannelsTrigger', Math.random());
            } else {
                window.location = liveVideoService.getLiveUrl(
                    liveVideoCard.video.identifier,
                );
            }
        },
    },
    helpers: {
        playerPageUrl: function(options) {
            return RouteCreator.playerDetail(options.context.identifier);
        },
        holesPageUrl: function(options) {
            return RouteCreator.holeDetail(options.context.identifier);
        },
    },
});
